import {signInWithEmailAndPassword} from "../data/user_api";

export const isSessionExpiringSoon = () => {
  const ONE_HOUR = 60 * 60;
  const stored = localStorage.getItem('authentication_headers');

  // Nothing in storage → can’t check expiry
  if (!stored) {
    return true;
  }

  let parsed;
  try {
    parsed = JSON.parse(stored);
  } catch (e) {
    console.error('Invalid authentication_headers JSON:', e);
    return true;
  }

  // Make sure expiry exists
  if (!parsed || !parsed.expiry) {
    return true;
  }

  const userExpiry = parsed.expiry;
  const currentEpoch = Math.floor(Date.now() / 1000);
  return (userExpiry - currentEpoch) <= ONE_HOUR;
};

export const refreshUserToken = async (email,password,otp_attempt) => {
    let resp = await signInWithEmailAndPassword(email,password,otp_attempt);
    return resp;
};


// WEBPACK FOOTER //
// ./src/utils/validate_session_expiry.js